import * as React from "react";

export function Sheet({ open, onOpenChange, children, ...props }: any) {
  return open ? <div {...props}>{children}</div> : null;
}
export function SheetContent({ children, ...props }: any) {
  return <div {...props}>{children}</div>;
}
export function SheetHeader({ children, ...props }: any) {
  return <div {...props}>{children}</div>;
}
export function SheetTitle({ children, ...props }: any) {
  return <h2 {...props}>{children}</h2>;
}
export function SheetDescription({ children, ...props }: any) {
  return <p {...props}>{children}</p>;
}
